/* axios setting : 서버와 통신하는 HTTP Request 라이브러리 설정 파일 */

import axiosInstance from 'axios';
import store from '../store';
import router from '../router';
import { SERVER_URL } from '../config/const';

// * npm run serve 실행 시 NODE_ENV 기본값 'development'
// * npm run build 실행 시 NODE_ENV 기본값 'production'
// * default -> 'development'
axiosInstance.defaults.baseURL = process.env.NODE_ENV === 'development' ? SERVER_URL.DEVELOPMENT : SERVER_URL.PRODUCTION;

// ? axios request전에 항상 실행되는 Hook.
axiosInstance.interceptors.request.use(
    config => {
        config.headers.authorization = `Bearer ${store.state.accessToken}`;
        return config;
    },
    error => Promise.reject(error)
)

// ? axios response을 받자마자 항상 사용되는 Hook.
axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
        // GLOBAL ERROR HANDLER
        const errorResponse = error.response.data;
        if (errorResponse.status === 401 && errorResponse.message === 'INVALID_TOKEN') {
            // * refreshToken이 만료되거나, accessToken의 내용이 user DB에 존재하지 않을 때
            store.commit('DEL_TOKEN');
            alert('로그아웃 되었습니다.');
            router.push('/');


            // if (router.history.current.path !== "/") {
            //     store.commit('DEL_TOKEN');
            //     alert('로그아웃 되었습니다.');
            //     router.push('/');
            // }
        } else if (errorResponse.status === 401 && errorResponse.message === 'EXPIRE_TOKEN') {
            // * accessToken이 만료 되었을 때, refreshToken을 가져와서 새로운 accessToken을 발급 받는다.
            const token = await axiosInstance.post('/token', {
                refresh_token: store.state.refreshToken
            });
            store.commit('SET_TOKEN', token.data);
            return axiosInstance.request(error.config);
        } else {
            return Promise.reject(error);
        }
    }
)

export default axiosInstance;